module.exports = __webpack_public_path__ + "media/images/icons/birthday-c5ce3dd491f972c0ac5e230af6df3b8a.svg";